import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ROLE } from '@/modules/role/router';
import { roleService } from '@/services/role';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useSysRoleAdd() {
    const router = useAppRouter();

    const model = reactive({
        email: null,
        role: null
    });

    const validations = {
        email: { required },
        role: { required }
    };

    const v$ = useVuelidate(validations, model);

    const addRole = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => {
            const isAccountId = /^\d+$/.test(model.email);
            const accountId = isAccountId ? model.email : null;
            const email = isAccountId ? null : model.email;

            return roleService.system.add(accountId, email, model.role);
        },
        onSuccess: () => router.push({ name: ROUTE_NAME_ROLE.SYSTEM.INDEX })
    });

    return { model, v$, fetch, addRole, roleOption };
}

const roleOption = [
    { value: 'ROLE_TESTER', label: 'Tester' },
    { value: 'ROLE_MODERATOR', label: 'Moderator' },
    { value: 'ROLE_MANAGER', label: 'Manager' },
    { value: 'ROLE_ADMIN', label: 'Admin' },
    { value: 'ROLE_SUPER_USER', label: 'Super User' }
];
